import { getInsight } from './card01.insights';
import { getAttention } from './card02.attention';
import { getStatus } from './card03.status';

export function leadershipEngine(metrics) {
  return {
    insight: getInsight(metrics),
    attention: getAttention(metrics),
    status: getStatus(metrics.honorariosMeses),
  };
}
